<template>
    <div class="no_room_for_error">
        <h2 class="pageTitle">不容错条件发布</h2>
        <div class="tips">温馨提示:任一类型不容错条件组10期总准确率为<b style="color: red">93%</b> , 才可以收费</div>
        
        <div style="margin-top: 1.1111rem;">
            <el-select v-model="select" @change="handleSelectChange" placeholder="请选择彩种">
                <el-option label="双色球" value="pre_double_publish_type"></el-option>
                <el-option label="大乐透" value="pre_lottery_publish_type"></el-option>
            </el-select>
        </div>
        
        <div class="title">1,填写不容错条件发布标题</div>
        <div class="block">
            [{{ vuex_userInfo.userName }}]{{ lotteryName }}第（{{ form.number }}）期技巧师excel发布
            <div style="margin: .5556rem 0;">
                在本站上有10期以上原始记录
                <el-radio-group v-model="form.isRecode" size="mini" style="margin-left: .5556rem;">
                    <el-radio-button :label="true">是</el-radio-button>
                    <el-radio-button :label="false">否</el-radio-button>
                </el-radio-group>
            </div>
        
        </div>
        
        <div class="title">2,当前发布是否收费</div>
        <div class="block">
            <!-- 是否收费-->
            <div class="isToll">
                <el-radio-group v-model="isToll" size="giant" @change="handleIsTollChange">
                    <el-radio-button :label="false">免费</el-radio-button>
                    <el-radio-button :label="true">收费</el-radio-button>
                </el-radio-group>
                <el-select v-model="form.coin" v-if="isToll">
                    <el-option v-for="(item,index) of 50" :value="index" :label="index + '缩币'" :key="index"></el-option>
                </el-select>
            </div>
        </div>
        
        <div class="title">3,选择发布不容错条件组(任选) <b style="color: red;">鼠标单击切换上传.txt条件组</b></div>
        <div class="block two" v-loading="condition_group_loading">
            <ul>
                <li v-for="(item,index) of condition_group" :key="index"
                    @click="toggleConditionGroup(item,index)"
                >
                    {{ item.dictLabel }} ({{ item?.type_num?.dictLabel }})
                    <span v-if="item.loading">
                        <i class="icon el-icon-loading"></i>
                        上传中...
                    </span>
                    <i class="icon el-icon-check" v-if="item.success"></i>
                </li>
            </ul>
        </div>
        
        <input type="file" :data-itemIndex="inputFileItemIndex" @change="handleFileChange($event)" style="display: none;"/>
        
        <div class="title">4,确定发布不容错条件</div>
        <div class="block">
            <div v-for="(item,index) of form.info" :key="index">{{ item.name }}----{{ item.fileName }}
                <el-button type="text" style="color:red;" @click="deleteFile(index,item)">删除</el-button>
            </div>
        </div>
        
        <!-- 预测说明 -->
        <div class="forecast_description">
            <span>预测说明</span>
            <textarea v-model="form.remark" name="" id="" cols="30" rows="10" placeholder="温馨提示：没有永远正确的规律，规律始终在周期性的运动。自我评估本期自己图表截图的可靠性，当然想提高自己的被认购率还是要靠真实的成绩。"></textarea>
        </div>
        
        <!-- pageMsg -->
        <div class="pageMsg">注意：EXCEL表建议自己杀毒后再上传！一旦excel病毒扩散到我们的技术员电脑，将警告一次，并给予暂取消技巧师资格1个星期的处分。</div>
        
        <el-button type="primary" class="submit" @click="confirmPublish">确认发布</el-button>
    
    </div>
</template>
<script>
import {queryNumber} from "@/api/personalCenter.js"
import {queryDictionary, queryUuIdInfo} from "@/api/common";
import {mapState} from "vuex";

export default {
    computed: {
        ...mapState(['vuex_userInfo']),
        lotteryName() {
            let obj = {pre_double_publish_type: '双色球', pre_lottery_publish_type: '大乐透'}
            return obj[this.select]
        }
    },
    data() {
        return {
            // 条件组
            condition_group: [],
            condition_group_loading: false,
            selectedValue: '',
            
            tableList: [],
            select: 'pre_double_publish_type',
            
            form: {
                preType: '',
                title: '',
                coin: '',
                remark: '',
                excelType: '1',
                isRecode: false,
                number: '',
                info: [],
            },
            
            inputFileItemIndex: '',
            
            isToll:'',
        }
    },
    mounted() {
        this.handleSelectChange('pre_double_publish_type')
    },
    methods: {
        handleIsTollChange(){
            if(!this.isToll){
                this.form.coin = 0
            }
        },
        async handleSelectChange(type) {
            // 获取当前彩种最新期号(ssq:0, dlt:1)
            let lotteryType = {'pre_double_publish_type': 0, 'pre_lottery_publish_type': 1}
            queryNumber(lotteryType[type]).then(res => this.form.number = res.data.next)
            
            this.condition_group_loading = true
            this.condition_group = []
            let {data} = await queryDictionary(type)
            let condition_group = data.map(item => ({dictLabel: item.dictLabel, dictValue: item.dictValue}))
            
            for (const item of condition_group) {
                let {data: type_num} = await queryDictionary(item.dictValue)
                item.rule = item.dictLabel.split('=')[1];
                item.loading = false;
                item.success = false;
                (type_num.length > 0) && (item.type_num = {dictLabel: type_num[0].dictLabel, dictValue: type_num[0].dictValue});
            }
            // console.log('new_condition_group',JSON.parse(JSON.stringify(condition_group)))
            this.condition_group = condition_group
            this.condition_group_loading = false
        },
        
        // 切换条件组
        toggleConditionGroup(item, index) {
            document.querySelector('input[type="file"]').click()
            this.selectedValue = item.dictValue
            this.inputFileItemIndex = index
        },
        // 上传文件
        async handleFileChange(e) {
            
            // this.tableList.push(e.target.files[0].name)
            
            const data = {file: e.target.files[0]};
            const params = this.$utils.getParamByJson({
                bizId: await queryUuIdInfo(),
                fileType: "excel_release_txt",
                number: 1
            })
            
            this.condition_group[this.inputFileItemIndex].loading = true
            
            this.$utils.upLoadFile('?' + params, data).then((res) => {
                console.log("upLoadFile", res);
                // this.tableList.push(res.data)
                this.form.info.push({
                    ...handle_publicationConditions_params.bind(this)(),  //不容错条件组
                    txt: res.data.urls,  //不容错条件组对应的txt文件
                    fileName: res.data.fileNames,
                })
                this.condition_group[this.inputFileItemIndex].success = true
                this.condition_group[this.inputFileItemIndex].loading = false
            }).catch(err => {
                console.log('err', err);
                this.condition_group[this.inputFileItemIndex].loading = false
                this.condition_group[this.inputFileItemIndex].success = false
            }).finally(() => {
                console.log('finally')
                e.target.value = '';
                this.condition_group[this.inputFileItemIndex].loading = false
            });
            
            
            function handle_publicationConditions_params() {
                let item = this.condition_group.filter(item => item.dictValue === this.selectedValue)[0]
                return {
                    publicationConditions: `${this.selectedValue}${item?.type_num ? '&' + item?.type_num.dictValue : ''}`,
                    name: item.dictLabel + `${item?.type_num ? `(${item?.type_num?.dictLabel})` : ''}`,
                }
            }
        },
        
        // 删除已上传文件
        deleteFile(index, item) {
            
            let taggetIndex = null
            this.condition_group.forEach((ite, idx) => {
                let name = ite.dictLabel + `(${ite?.type_num?.dictLabel})`
                if (name === item.name) {
                    taggetIndex = idx
                }
            })
            
            this.$confirm('确定删除该文件吗？', '提示', {type: 'warning'}).then(res => {
                this.form.info.splice(index, 1)
                
                this.condition_group[taggetIndex].loading = false
                this.condition_group[taggetIndex].success = false
                
            }).catch(err => {
            })
        },
        
        // 确认发布
        confirmPublish() {
            let lotteryType = {'pre_double_publish_type': 0, 'pre_lottery_publish_type': 1}
            this.form.preType = lotteryType[this.select]
            this.form.title = `[${this.vuex_userInfo.userName}]${this.lotteryName}第(${this.form.number})期技巧师excel发布`
            
            this.$http.post('/stage-api/technician/release/excel', this.form).then(res => {
                if (res.code === 200) {
                    this.$message.success('发布成功')
                } else {
                    this.$message.error(res.msg)
                }
            }).catch(err => {
                console.log('err', err);
            });
            
            // console.log('form', JSON.parse(JSON.stringify(this.form)));
        },
    }
}
</script>

<style lang="scss" scoped>
.block.two {
    ul {
        width: 100%;
        list-style: none;
        padding-left: 0;
        margin: 0;
        
        li {
            height: 45px;
            line-height: 45px;
            border-bottom: 1px solid #dadada;
            cursor: pointer;
            
            &:hover {
                background-color: #f5f5f5;
            }
            
            span {
                color: red;
            }
            
            .el-icon-check {
                font-weight: bold;
                color: green;
                zoom: 2;
            }
        }
    }
    
    //.el-radio-group {
    //    display: flex;
    //    flex-direction: column;
    //    gap: 0.5556rem;
    //    .el-radio__label {
    //        font-weight: bold !important;
    //    }
    //}
}

.title {
    padding: 0.5556rem;
    background-color: #e9f6fd;
    margin-top: 0.5556rem;
}

.block {
    padding: 1.1111rem;
    box-sizing: border-box;
    
    &.two {
        display: flex;
        flex-wrap: wrap;
        gap: 0.5556rem;
    }
}

.pageTitle {
    margin-top: 0;
}

.forecast_description {
    display: flex;
    align-items: flex-start;
    
    textarea {
        flex: 1;
        margin-left: 1.1111rem;
        resize: none;
        padding: 0.5556rem;
        box-sizing: border-box;
    }
}

.pageMsg {
    color: red;
    font-size: 0.7778rem;
    font-weight: bold;
    margin: 1.1111rem auto;
    text-align: center;
}

.submit {
    display: block;
    margin: auto;
    width: fit-content;
}
</style>
